/**
 * Route Definitions
 *
 * Central configuration for all application routes.
 * Matches Vue router configuration.
 */

/**
 * Routes that require authentication and authorization check
 */
export const PROTECTED_ROUTES = [
  "/booking",
  "/office",
  "/admin",
  "/superadmin",
];

/**
 * Route paths as constants
 */
export const ROUTES = {
  HOME: "/",
  BOOKING: "/booking",
  OFFICE: "/office",
  ADMIN: "/admin",
  SUPERADMIN: "/superadmin",
  FORBIDDEN: "/forbidden",
  NOT_FOUND: "*",
} as const;

/**
 * Default redirect path after login
 */
export const DEFAULT_REDIRECT = ROUTES.BOOKING;

/**
 * Check if a route requires protection
 */
export function isProtectedRoute(path: string): boolean {
  return PROTECTED_ROUTES.includes(path);
}
